import React from 'react';

export interface ChartTooltipProps {
  /** Pointer position in viewport pixels (clientX / clientY); the tooltip sits just above it, centred. */
  x: number;
  y: number;
  label: React.ReactNode;
  /** Shown bold after the label, e.g. a percentage. */
  value?: React.ReactNode;
  /** Swatch colour matching the hovered segment. */
  color?: string;
  dataCy?: string;
}

/** The share of `base` that `value` is, to one decimal, e.g. "40.0%". */
export const formatShare = (value: number, base: number): string => `${((value / base) * 100).toFixed(1)}%`;

/**
 * A small hover label for a chart segment. Fixed to the viewport, so a chart that clips its overflow (a rounded bar,
 * a scrolling table) cannot cut it off. Pointer-only and aria-hidden: the chart's own accessible name carries the
 * figures for assistive technology.
 */
const ChartTooltip: React.FC<ChartTooltipProps> = ({ x, y, label, value, color, dataCy = 'chart-tooltip' }) => (
  <div className="chart-tooltip" aria-hidden="true" style={{ left: x, top: y }} data-cy={dataCy}>
    {color && <span className="chart-tooltip-swatch" style={{ backgroundColor: color }} />}
    <span>
      {label}
      {value !== undefined && (
        <>
          : <strong>{value}</strong>
        </>
      )}
    </span>
  </div>
);

export default ChartTooltip;
